<template>
  <div class="demo-spin-article">
    <div class="ls_action_header">
      <Row class="ls_action_header mb-50" type="flex" justify="space-between" style="padding: 5px">

        <Col :xs="24" :sm="24" :md="14">
          <Row type="flex" :gutter="24">
            <Col :xs="24" :sm="12" :md="0" class="mb-10">
              <!-- BULK ACTIONS-->
              <Button
                type="info"
                class="ls_bulk_delete_button w-md-100"
                :disabled="selected.length === 0"
                @click="fetchReport"
              >Скачать отчет
              </Button>
            </Col>

            <Col :xs="24" :sm="12" :md="0" class="mb-10">
              <Select
                v-model="reportType"
                class="w-md-100"
                placeholder="Выберите тип отчета"
              >
                <Option
                  value="period_report"
                >{{ reportTypeOptions.period_report }}
                </Option>
                <Option
                  value="period_ticket_report"
                >{{ reportTypeOptions.period_ticket_report }}
                </Option>
              </Select>
            </Col>
          </Row>

        </Col>


        <Col
          align="right"
          :xs="24" :sm="24" :md="10"
        ><DatePicker
          v-model="periodDate"
          @on-change="changePeriodDate"
          format="dd.MM.yyyy"
          type="daterange"
          :start-date="currentDate"
          placeholder="Период"
          class="datepicker_style"
          :clearable="false"
        ></DatePicker
        ></Col>

      </Row>
    </div>
    <!-- DATA TABLE + PAGINATION -->
    <Table
      class="desktop_table"
      :loading="loading"
      :columns="columns"
      :data="data"
      style="overflow: visible"
      @on-sort-change="changeSorting"
      @on-selection-change="onSelectChange"
    ></Table>

    <!-- DATA MOBILE TABLE -->
    <div class="mobile-table">

      <div v-for="item in data" class="card-container">

        <div>
          <h2>{{item.name}}</h2>
          <p>Наименование точки продаж: {{item.point.name}}</p>
          <p>Регистрационный номер: {{item.regNumber}}</p>
          <p>Дата окончания срока подписки: {{item.expirationDate}}</p>
        </div>

        <div>
          <input type="checkbox" v-model="selected" :value="item.cashId">
        </div>


      </div>
    </div>



<!--    <Page-->
<!--      :total="totalRecords"-->
<!--      :page-size="pageSize"-->
<!--      :page-size-opts="[12, 24, 30]"-->
<!--      @on-change="changePage"-->
<!--      @on-page-size-change="changePageSize"-->
<!--      show-sizer-->
<!--      :styles="{ marginTop: '30px', float: 'right' }"-->
<!--    />-->
  </div>
</template>
<script>
import {
  formatNumber,
  formatDate,
  formatDateTime,
  b64DecodeUnicode
} from "../../base/base_func.js";
import { base_url } from "../../http.js";
import { BaseTableData } from "../../base/base_table.js";

let _app = BaseTableData();

_app.data = function() {
  return {
    // Base settings
    baseViewUrl: base_url + "/cashes/",
    item_type: "reports",
    loading: true,

    // Table settings
    columns: [
      {
        type: "selection",
        width: 60,
        align: "center",
        // key: "cashId"
      },
      {
        title: "Наименование кассы",
        // width: 340,
        key: "name"
        // sortable: true,
      },
      {
        title: "Наименование точки продаж",
        // width: 340,
        key: "point",
        // sortable: true,
          render: (h, params) => {
            return h("span", {}, params.row.point.name);
          }
      },
      {
        title: "Регистрационный номер",
        // width: 340,
        key: "regNumber"
        // sortable: true,
      },
      // {
      //   title: "Статус кассы",
      //   // width: 340,
      //   key: "name"
      //   // sortable: true,
      // },
      {
        title: "Дата окончания срока подписки",
        // width: 340,
        key: "expirationDate"
        // sortable: true,
      },
      // {
      //   title: "№ смена",
      //   // width: 340,
      //   key: "number"
      //   // sortable: true,
      // },
      // {
      //   title: "Дата открытия",
      //   key: "open_date",
      //   sortable: true,
      //   render: (h, params) => {
      //     return h("span", {}, formatDateTime(params.row.open_date));
      //   }
      // },
      // {
      //   title: "Дата закрытия",
      //   key: "close_date",
      //   sortable: true,
      //   render: (h, params) => {
      //     return h("span", {}, formatDateTime(params.row.close_date));
      //   }
      // },
      // {
      //   title: "Отчеты",
      //   align: "center",
      //   render: (h, params) => {
      //     return h("Dropdown", { props: { trigger: "click" } }, [
      //       h("Button", { props: {type: "primary"} }, [
      //         "Отчеты",
      //         h("Icon", { type: "ios-arrow-down" })
      //       ]),
      //       // h("a", { href: "javascript:void(0)" }, [
      //       //   "Отчеты",
      //       //   h("Icon", { type: "ios-arrow-down" })
      //       // ]),
      //       h("DropdownMenu", { slot: "list" }, [
      //         h(
      //           "DropdownItem",
      //           {
      //             nativeOn: {
      //               click: this.showReportAction(REPORT.Z_REPORT, params.row.id)
      //             }
      //           },
      //           "Просмотр Z-отчета"
      //         ),
      //         h(
      //           "DropdownItem",
      //           {
      //             nativeOn: {
      //               click: this.showReportAction(
      //                 REPORT.SECTION_REPORT,
      //                 params.row.id
      //               )
      //             }
      //           },
      //           "Отчет по секциям"
      //         ),
      //         h(
      //           "DropdownItem",
      //           {
      //             nativeOn: {
      //               click: this.showReportAction(
      //                 REPORT.CASHIER_REPORT,
      //                 params.row.id
      //               )
      //             }
      //           },
      //           "Отчет по кассирам"
      //         ),
      //         h(
      //           "DropdownItem",
      //           {
      //             nativeOn: {
      //               click: this.showReportAction(
      //                 REPORT.CONTROL_TAPE,
      //                 params.row.id
      //               )
      //             }
      //           },
      //           "Контрольная лента"
      //         )
      //       ])
      //     ]);
      //   }
      // }
    ],
    data: [],
    // lastDraw: 0,
    // totalRecords: null,
    // currentPage: 1,
    // pageSize: 12,
    // sorting: "",
    // startDateDefault: new Date(),
    // endDateDefault: '',

    periodDate: ["", ""],
    period: {
      start_date: "",
      end_date: ""
    },
    selected: [],

    reportType: "period_report",
    reportTypeOptions: {
      period_report: "Сводный отчет",
      period_ticket_report: "Отчет по чекам"
    }
  };
};

_app.computed.fetchParams = function() {
  let params = {
    draw: this.lastDraw,
    // offset: this.start,
    // limit: this.pageSize,
    // search: this.searchString,
    // ordering: this.sorting
  };

  // for (let key in this.filter) {
  //   if (this.filter[key]) {
  //     params[key] = this.filter[key];
  //   }
  // }

  return params;
};

_app.computed.currentDate = function(){
  let date = new Date();
  date.setMonth(date.getMonth() - 1);
  return date;
};



_app.methods.onSelectChange = function(selection) {
  this.selected = [];
  for (let row of selection) {
    this.selected.push(row.cashId);
  }
};


// Загружаем данные для таблицы
_app.methods.fetchItems = function() {
  this.loading = true;
  this.lastDraw++;
  let url = base_url + "/proxy/cashboxes/";
  this.$http
    .get(url, {
      params: this.fetchParams
    })
    .then(result => {
      // if (result.data.draw === this.lastDraw) {
        this.data = result.data;
        // this.totalRecords = result.data.count;
      // }
    })
    .finally(() => {
      this.loading = false;
    });
};

_app.methods.changePeriodDate = function(date_arr, date_obj) {
  if (date_arr[0] && date_arr[1]) {
    this.period.start_date = this.periodDate[0];
    this.period.end_date = this.periodDate[1];
  }
};
// Очистка полей поиска даты документа (Order date), после чего срабатывает watcher и обновляются данные в таблице
_app.methods.clearPeriodDate = function(date_arr, date_obj) {
  // this.period.start_date = "";
  // this.period.end_date = "";
};

_app.methods.formatNumber = function(number) {
  return formatNumber(number);
};

_app.methods.fetchReport = function() {
  // window.onbeforeunload = function () {};
  //
  // location.href = base_url + "/product_order/pdf/";
  //
  // window.onbeforeunload = function () {
  //   return "Вы уверены, что хотите закрыть приложение?";
  // };

  // Создаем новые объекты Date, чтобы не менять this.periodDate напрямую
  const startDate = new Date(this.periodDate[0]);
  const endDate = new Date(this.periodDate[1]);

  // Получаем разницу в минутах между локальным часовым поясом и UTC
  const timeZoneOffset = startDate.getTimezoneOffset();

  // Корректируем только часовой пояс на каждой дате
  if (timeZoneOffset < 0){
  startDate.setMinutes(startDate.getMinutes() - timeZoneOffset);
  endDate.setMinutes(endDate.getMinutes() - timeZoneOffset);
  }
  else {
  startDate.setMinutes(startDate.getMinutes() + timeZoneOffset);
  endDate.setMinutes(endDate.getMinutes() + timeZoneOffset);
  }

  const url = `${base_url}/proxy/reports/${this.reportType}/`;
  this.$http({
    url: url,
    method: "POST",
    data: {
      cashboxes: this.selected,
      start_date: startDate.toISOString(),
      end_date: endDate.toISOString(),
    },
    responseType: "blob" // important
  })
    .then(response => {
      const blob = new Blob([response.data], { type: "application/octet-stream;charset=utf-8" });
      // console.log('blob:', blob)
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      // the filename you want
      // console.log(response);
      // let headerLine = response.headers['content-disposition'];
      // let startFileNameIndex = headerLine.indexOf('"') + 1;
      // let endFileNameIndex = headerLine.lastIndexOf('"');
      // let filename = headerLine.substring(startFileNameIndex, endFileNameIndex);

      // a.download = `${this.doc_templates_obj[type]}.pdf`;
      a.download = `PeriodReport.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    })
    .catch(error => {
      this.$Message.error("Произошла ошибка. Попробуйте позже.");
      console.log(error);
    });
};

_app.created = function () {
  let start_date = new Date();
  let end_date = new Date();

  start_date.setDate(start_date.getDate() - 7).toString();

  this.periodDate[0] = start_date;
  this.periodDate[1] = end_date;

  this.period.start_date = start_date;
  this.period.end_date = end_date;
};

export default _app;
</script>

<style scoped>
.report_body {
  /*width: 420px;*/
  box-sizing: border-box;
  color: rgb(0, 0, 0);
  font-family: Consolas, serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 15px;
  overflow-wrap: break-word;
  pointer-events: auto;
  text-align: left;
  white-space: pre-wrap;
}
.report_text {
  display: flex;
  justify-content: center;
  overflow: hidden;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  font-family: Consolas;
  line-height: 15px;
  font-size: 15px;
  font-weight: 400;
  font-style: normal;
  color: #000;
  background-color: transparent;
}

  .datepicker_style {
    width: 240px;
  }

@media screen and (max-width: 767px) {
  .datepicker_style {
    width: 100%;
  }

}
</style>



<style>
  @media screen and (max-width: 767px) {

    .w-md-100 {
      width: 100%;
    }
    .datepicker_style .ivu-date-picker input.ivu-input {
      max-width: 100%;
    }
  }


  @media (min-width: 768px) {
    .ivu-col-span-md-0 {
      display: block;
      width: auto;
    }

  }
</style>



// WEBPACK FOOTER //
// src/apps/report/cashPeriodReport.vue